import React from 'react';
import { Button } from '@askporter/component-library/Button';
import Box from '@mui/material/Box';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
interface InitialViewProps {
  t: (key: string) => string;
  setDialogView: (view: 'INITIAL' | 'CUSTOMISE') => void;
  handleAcceptAllOnClick: () => void;
  isSmallDevice: boolean;
}
const InitialView: React.FC<React.PropsWithChildren<InitialViewProps>> = ({
  t,
  setDialogView,
  handleAcceptAllOnClick,
  isSmallDevice,
}) => {
  return (
    <>
      <DialogTitle variant="h3">{t('cookie_banner:initial_view:title')}</DialogTitle>

      <Box display={isSmallDevice ? 'block' : 'flex'} justifyContent="space-between">
        <DialogContent>{t('cookie_banner:initial_view:description')}</DialogContent>
        <DialogActions sx={{ pr: 6, ml: 'auto' }} disableSpacing>
          <Button onClick={() => setDialogView('CUSTOMISE')}>{t('cookie_banner:initial_view:customise_button')}</Button>
          <Button variant="contained" sx={{ ml: 6 }} onClick={handleAcceptAllOnClick}>
            {t('cookie_banner:initial_view:accept_button')}
          </Button>
        </DialogActions>
      </Box>
    </>
  );
};
export default InitialView;
